import { render } from "./ExampleAvatar.vue?vue&type=template&id=b7ae1f6a"
import script from "./ExampleAvatar.vue?vue&type=script&lang=js"
export * from "./ExampleAvatar.vue?vue&type=script&lang=js"

import "./ExampleAvatar.vue?vue&type=style&index=0&id=b7ae1f6a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__